import React from 'react';
import {Pagination, PaginationItem, PaginationLink} from '@Comp';


const ExampleOne = () => (
    <Pagination>
        <PaginationItem disabled>
            <PaginationLink previous href="#" />
        </PaginationItem>
        <PaginationItem active>
            <PaginationLink href="#">
                1
            </PaginationLink>
        </PaginationItem>
        <PaginationItem>
            <PaginationLink href="#">
                2
            </PaginationLink>
        </PaginationItem>
        <PaginationItem>
            <PaginationLink href="#">
                3
            </PaginationLink>
        </PaginationItem>
        <PaginationItem>
            <PaginationLink href="#">
                4
            </PaginationLink>
        </PaginationItem>
        <PaginationItem>
            <PaginationLink href="#">
                5
            </PaginationLink>
        </PaginationItem>
        <PaginationItem>
            <PaginationLink next href="#" />
        </PaginationItem>
    </Pagination>
);

const ExampleTwo = () => (
    <Pagination size="lg">
        <PaginationItem>
            <PaginationLink previous href="#" />
        </PaginationItem>
        <PaginationItem>
            <PaginationLink href="#">
                1
            </PaginationLink>
        </PaginationItem>
        <PaginationItem>
            <PaginationLink href="#">
                2
            </PaginationLink>
        </PaginationItem>
        <PaginationItem>
            <PaginationLink href="#">
                3
            </PaginationLink>
        </PaginationItem>
        <PaginationItem>
            <PaginationLink next href="#" />
        </PaginationItem>
    </Pagination>
);

const PaginationExample = () => (
    <div className="mb-5">
        <ExampleOne/>
        <ExampleTwo/>
    </div>
);

export default PaginationExample;
